import { render, staticRenderFns } from "./OrderRestorationDialog.vue?vue&type=template&id=cdc7acbc&scoped=true&"
import script from "./OrderRestorationDialog.vue?vue&type=script&lang=js&"
export * from "./OrderRestorationDialog.vue?vue&type=script&lang=js&"
import style0 from "./OrderRestorationDialog.vue?vue&type=style&index=0&id=cdc7acbc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc7acbc",
  null
  
)

export default component.exports